<template>
  <div>
    <v-toolbar class="pt-4" extended flat extension-height="50" style="border-bottom: 1px solid grey" height="60px">

      <img v-if="undefined !== clientLogo || clientLogo.trim().length > 0" :src="getHeaderImageUrl()" class="imageSize" alt="logo"/>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <LocaleSwitcher></LocaleSwitcher>
      </v-toolbar-items>
      <v-btn color="primary" class="hidden-md-and-up" @click="toggleMenu = !toggleMenu">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="hidden-md-and-up" v-if="toggleMenu">
      <LocaleSwitcher></LocaleSwitcher>
    </div>
  </div>

</template>
<script>
import { apiUrl } from '../_config'
import LocaleSwitcher from '../components/LocaleSwitcher'

export default {
  components: {
    LocaleSwitcher
  },
  props: {
    clientLogo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      toggleMenu: false
    }
  },
  methods: {
    getHeaderImageUrl: function () {
      return apiUrl() + 'media/logo/' + this.clientLogo
    }
  }
}
</script>
<style>
  .imageSize {
    height: 60px;
  }
</style>
